import './polyfills/abortTimeout'
import { createRoot } from 'react-dom/client'
import App from './App'
import './i18n'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './authConfig'

import '@design-systems/formatted-tokens/dist/enterprise-tokens/theme.css'
import '@design-systems/canvas-ui/dist/esm/src/styles/global/_helper-classes.css'
import './styles/index.scss'

window.__mpmStartupBridge?.booting()

const enableMocking = async () => {
    if (process.env.REACT_APP_ENV === 'msw') {
        const { worker } = await import('./mocks/msw')
        await worker.start()
    }
}

const msalInstance = new PublicClientApplication(msalConfig)
const root = createRoot(document.getElementById('root') as HTMLElement)

const renderApp = () =>
    root.render(
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>,
    )

msalInstance
    .initialize()
    .catch(() => {
        // PowerBI initialization failures must not prevent application startup.
    })
    .finally(() => {
        enableMocking()
            .catch(() => {
                // MSW setup failures must not prevent application startup.
            })
            .finally(renderApp)
    })
